import * as React from 'react';
import styled from 'styled-components'

import {Client} from "../../../domain/model/client";
import {Company} from "../../../domain/model/company";

import AvatarLarge from "../atom/avatar/avatar_large";
import HeadlineMiddle from "../atom/text/headline_middle";
import ParagraphSup from "../atom/text/paragraph_sup";
import LabelJob from "../atom/label/label_job";

interface IProps {
    client: Client;
    company: Company;
}

const ClientProfile: React.FC<IProps> = (props) => {

    const { client, company } = props;

    return (

        <Wrapper>
            <AvatarWrapper>
                <AvatarLarge src={client.getIconURL()} />
            </AvatarWrapper>
            <CompanyWrapper>
                <Flex>
                    <Position>{client.position}</Position>
                    <HeadlineMiddle>{company.name}</HeadlineMiddle>
                </Flex>
            </CompanyWrapper>
            <ClientWrapper>
                <ParagraphSup bold={true}>{client.nameKana}</ParagraphSup>
                <HeadlineMiddle>{client.name}</HeadlineMiddle>
            </ClientWrapper>
        </Wrapper>
    );
};

export default ClientProfile;

const Wrapper = styled.div`
    margin: 40px auto;
    text-align: center;
`;

const AvatarWrapper = styled.div`
    margin-bottom: 10px;
`;

const CompanyWrapper = styled.div`
    margin-bottom: 15px;
`;

const ClientWrapper = styled.div`
    margin-bottom: 15px;
`;

const Position = styled(LabelJob)`
    margin-right: 10px;
`;

const Flex = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;


// WEBPACK FOOTER //
// ./src/presentation/common/organism/client_profile.tsx